import { Injectable } from '@angular/core';

import { AppConfiguration } from '../../../bootstrap/climatecare/app.configuration';
import { FFPEncryptor } from './ffp-encryptor';
import type { FFPKeyMaterial } from './ffp-encryptor';

@Injectable({ providedIn: 'root' })
export class FfpEncryptorService {

  private encryptor: FFPEncryptor;

  constructor(private appConfiguration: AppConfiguration) { }

  private getEncryptor(): FFPEncryptor {
    if (!this.encryptor) {
      const material: FFPKeyMaterial = this.appConfiguration.clientConfiguration.clientSettings.webService.cnAir.ffpEncryptor;
      this.encryptor = new FFPEncryptor(material);
    }
    return this.encryptor;
  }

  encrypt(plaintext: string): Promise<string> {
    return this.getEncryptor().encrypt(plaintext);
  }

  decrypt(encryptedHex: string): Promise<string> {
    return this.getEncryptor().decrypt(encryptedHex);
  }
}
